<template>
<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Label`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_1de8db955a__clip0_559_1491)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 10.4C8.65391 10.4 10.4 8.65391 10.4 6.5C10.4 4.34609 8.65391 2.6 6.5 2.6C4.34609 2.6 2.6 4.34609 2.6 6.5C2.6 8.65391 4.34609 10.4 6.5 10.4ZM6.5 12C9.53757 12 12 9.53757 12 6.5C12 3.46243 9.53757 1 6.5 1C3.46243 1 1 3.46243 1 6.5C1 7.83972 1.47901 9.06757 2.2751 10.0216L1.50341 11.2061C1.28673 11.5387 1.52539 11.979 1.92235 11.979H5.99976L5.99641 11.9773C6.16226 11.9923 6.33023 12 6.5 12ZM6.5 7.5C7.05228 7.5 7.5 7.05228 7.5 6.5C7.5 5.94772 7.05228 5.5 6.5 5.5C5.94772 5.5 5.5 5.94772 5.5 6.5C5.5 7.05228 5.94772 7.5 6.5 7.5ZM6.5 9C7.88071 9 9 7.88071 9 6.5C9 5.11929 7.88071 4 6.5 4C5.11929 4 4 5.11929 4 6.5C4 7.88071 5.11929 9 6.5 9Z" :fill="useCurrentColor ? 'currentColor' : '#333'"/></g><defs><clipPath id="svg_1de8db955a__clip0_559_1491"><path :fill="useCurrentColor ? 'currentColor' : '#fff'" d="M0 0H14V14H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLabel',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
